<template>
  <Disclosure
    v-slot="{ open }"
    as="nav"
    class="border-b border-gray-200 bg-white"
  >
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex h-16 justify-between">
        <div class="flex">
          <div class="flex flex-shrink-0 items-center">
            <img
              class="block h-8 w-auto lg:hidden"
              src="@/assets/images/logo_llg_albums.png"
              alt="Local Loyalty Group"
            />
            <img
              class="hidden h-8 w-auto lg:block"
              src="@/assets/images/logo_llg_albums.png"
              alt="Local Loyalty Group"
            />
          </div>
          <div
            class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8 space-y-1 px-2 pb-3 pt-2"
          >
            <DisclosureButton
              v-for="(item, idx) in navigation"
              :key="item.name"
              as="a"
              :href="item.href"
              :class="[
                item.current
                  ? 'bg-black text-white'
                  : 'text-gray-900 hover:bg-black hover:text-white',
                'block rounded-md py-2 px-3 text-base font-medium',
                idx === 0 ? 'mt-1' : '',
              ]"
              :aria-current="item.current ? 'page' : undefined"
              >{{ item.name }}</DisclosureButton
            >
          </div>
        </div>
        <div class="hidden sm:ml-6 sm:flex sm:items-center">
          <button
            type="button"
            class="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">View notifications</span>
            <BellIcon class="h-6 w-6" aria-hidden="true" />
          </button>

          <!-- Profile dropdown -->
          <Menu as="div" class="relative ml-3">
            <div>
              <MenuButton
                class="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span
                  class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500"
                >
                  <span class="text-sm font-medium leading-none text-white">{{
                    abbreviation
                  }}</span>
                </span>
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <MenuItem
                  v-for="item in userNavigation"
                  :key="item.name"
                  v-slot="{ active }"
                >
                  <a
                    v-if="item.action === undefined"
                    :href="item.href"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    ]"
                    >{{ item.name }}</a
                  >
                  <a
                    v-else
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    ]"
                    @click="item.action"
                    >{{ item.name }}</a
                  >
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div class="-mr-2 flex items-center sm:hidden">
          <!-- Mobile menu button -->
          <DisclosureButton
            class="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">Open main menu</span>
            <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
            <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
      </div>
    </div>

    <DisclosurePanel class="sm:hidden">
      <div class="space-y-1 pb-3 pt-2">
        <DisclosureButton
          v-for="item in navigation"
          :key="item.name"
          as="a"
          :href="item.href"
          :class="[
            item.current
              ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
              : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800',
            'block border-l-4 py-2 pl-3 pr-4 text-base font-medium',
          ]"
          :aria-current="item.current ? 'page' : undefined"
          >{{ item.name }}</DisclosureButton
        >
      </div>
      <div class="border-t border-gray-200 pb-3 pt-4">
        <div class="flex items-center px-4">
          <div v-if="user !== null" class="ml-3">
            <div class="text-base font-medium text-gray-800">
              {{ user.name }}
            </div>
            <div class="text-sm font-medium text-gray-500">
              {{ user.email }}
            </div>
          </div>
          <button
            type="button"
            class="ml-auto flex-shrink-0 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <span class="sr-only">View notifications</span>
            <BellIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-3 space-y-1">
          <DisclosureButton
            v-for="item in userNavigation"
            :key="item.name"
            as="a"
            :href="item.href"
            class="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
            >{{ item.name }}</DisclosureButton
          >
        </div>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script lang="ts" setup>
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/vue";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { useAuthStore } from "~/store/auth";
import type { JwtResponse } from "~/store/auth";

const userStore = useAuthStore();
const user: JwtResponse | null = userStore.getUser;
const abbreviation = user?.name.slice(0, 2).toUpperCase() ?? "";
const { t: $t } = useI18n();

interface NavigationItem {
  name: string;
  href: string;
  action?: any;
}

const userNavigation: NavigationItem[] = [
  {
    name: $t("llg.scodi.user_navigation.log_out.label"),
    href: "#",
    action: userStore.logout,
  },
];

const isCurrentRoute = (path: string): boolean => {
  // https://github.com/nuxt/nuxt/issues/20471#issuecomment-1785954699
  // https://stackoverflow.com/a/77973082
  const router = useRouter();
  return router.currentRoute.value.name.includes(path);
};
const navigation = computed(() => {
  return [
    {
      name: $t("llg.scodi.header.campaign.label"),
      href: "/campaign",
      current: isCurrentRoute("campaign"),
    },
    {
      name: $t("llg.scodi.header.scodi.label"),
      href: "/scodi",
      current: isCurrentRoute("scodi"),
    },
    {
      name: $t("llg.scodi.header.reports.label"),
      href: "/reports",
      current: isCurrentRoute("reports"),
    },
    {
      name: $t("llg.scodi.header.users"),
      href: "/user",
      current: isCurrentRoute("user"),
    },
  ];
});
</script>
